// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-performance-watchdog-message-area {
  position: relative;
  background-color: yellow;
  color: black;
  padding: 10px;
}

.cesium-performance-watchdog-message {
  margin-right: 30px;
}

.cesium-performance-watchdog-message-dismiss {
  position: absolute;
  right: 0;
  margin: 0 10px 0 0;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/PerformanceWatchdog/PerformanceWatchdog.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB","sourcesContent":[".cesium-performance-watchdog-message-area {\n  position: relative;\n  background-color: yellow;\n  color: black;\n  padding: 10px;\n}\n\n.cesium-performance-watchdog-message {\n  margin-right: 30px;\n}\n\n.cesium-performance-watchdog-message-dismiss {\n  position: absolute;\n  right: 0;\n  margin: 0 10px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
